import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          {/* Left - Text */}
          <div className="lg:w-[42%]">
            <span className="inline-block px-3 py-1 rounded-full border border-foreground-200 text-xs font-medium text-foreground-500 mb-6 font-label">
              {t("about.tag")}
            </span>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-[1.05] mb-1">
              {t("about.title1")}
            </h2>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl italic font-light text-foreground-500 leading-[1.05] mb-10">
              {t("about.title2")}
            </h2>
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-8 max-w-[480px]">
              {t("about.text")}
            </p>
            <Link
              to="/guia-hoobuy-sheet"
              className="inline-flex items-center gap-2 text-base font-semibold text-foreground-900 border-b-2 border-foreground-300 hover:border-foreground-900 transition-colors pb-1 whitespace-nowrap"
            >
              {t("about.link")}
            </Link>
          </div>

          {/* Right - Stats + Images */}
          <div className="lg:w-[55%] flex flex-col gap-8">
            {/* Stats */}
            <div className="flex items-start justify-end gap-16">
              <div className="text-right">
                <p className="font-heading text-6xl md:text-7xl font-black text-foreground-950 leading-none">
                  {t("about.stat1")}
                </p>
                <p className="text-sm text-foreground-500 mt-2">{t("about.stat1.desc")}</p>
              </div>
              <div className="text-right">
                <p className="font-heading text-6xl md:text-7xl font-black text-foreground-950 leading-none">
                  {t("about.stat2")}
                </p>
                <p className="text-sm text-foreground-500 mt-2">{t("about.stat2.desc")}</p>
              </div>
            </div>

            {/* Image stack */}
            <div className="relative h-[320px] md:h-[380px] w-full">
              {/* Small square image - front */}
              <div className="absolute top-0 left-0 w-[160px] h-[160px] md:w-[200px] md:h-[200px] z-20 rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Close%20up%20detail%20shot%20of%20premium%20beige%20canvas%20sneakers%20with%20cream%20laces%20on%20warm%20sandstone%20surface%20soft%20directional%20daylight%20from%20side%20window%20highlighting%20textile%20texture%20minimalist%20product%20photography%20with%20shallow%20depth%20of%20field%20elegant%20editorial%20aesthetic%20no%20visible%20branding&width=400&height=400&seq=about-small-product-v3&orientation=squarish"
                  alt="Hoobuy sneakers detalhe"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Large portrait image - back */}
              <div className="absolute top-6 left-16 md:left-20 w-[260px] h-[320px] md:w-[340px] md:h-[400px] z-10 rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20editorial%20fashion%20photograph%20of%20relaxed%20street%20style%20outfit%20featuring%20oversized%20oatmeal%20colored%20knit%20sweater%20wide%20leg%20cream%20trousers%20and%20minimal%20accessories%20model%20standing%20against%20warm%20terracotta%20toned%20wall%20soft%20golden%20hour%20sunlight%20creating%20gentle%20highlights%20clean%20sophisticated%20aesthetic%20with%20organic%20warmth%20and%20refined%20simplicity&width=680&height=800&seq=about-large-fashion-v3&orientation=portrait"
                  alt="Hoobuy streetwear fashion editorial"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}